import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('umb-market-package-badge')
export class UmbMarketPackageBadge extends LitElement {
  @property()
  value?: string;

  render() {
    if (!this.value) {
      return null;
    }

    return html`<span id="badge">${this.value}</span>`;
  }

  static styles = [
    css`
      :host {
        --font-size: var(--badge-font-size, 12px);
        --font-weight: var(--badge-font-weight, 400);
      }

      #badge {
        border: 1px solid var(--color-border);
        box-sizing: border-box;
        font-size: var(--font-size);
        font-weight: var(--font-weight);
        height: var(--badge-height, var(--l-spacer));
        display: inline-flex;
        align-items: center;
        padding: 0 14px;
        border-radius: var(--s-spacer);
      }
    `,
  ];
}
